module.exports = {
  plus: [{
    text: 'Sangat Tidak Akurat',
    score: 1,
    color: 1
  }, {
    text: 'Sedikit Tidak Akurat',
    score: 2,
    color: 2
  }, {
    text: 'Antara Akurat Ataupun Tidak Akurat',
    score: 3,
    color: 3
  }, {
    text: 'Sedikit Akurat',
    score: 4,
    color: 4
  }, {
    text: 'Sangat Akurat',
    score: 5,
    color: 5
  }],
  minus: [{
    text: 'Sangat Tidak Akurat',
    score: 5,
    color: 1
  }, {
    text: 'Sedikit Tidak Akurat',
    score: 4,
    color: 2
  }, {
    text: 'Antara Akurat Ataupun Tidak Akurat',
    score: 3,
    color: 3
  }, {
    text: 'Sedikit Akurat',
    score: 2,
    color: 4
  }, {
    text: 'Sangat Akurat',
    score: 1,
    color: 5
  }]
};